<icon-component [iconName]="icon"></icon-component>
